import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import logo from './6.svg';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-yellow-03 text-white">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
          {/* Logo */}
          <div className="md:col-span-3 flex items-center">
            <img src={logo} alt="there2b" className="w-28 md:w-36 h-auto" />
          </div>

          {/* Nav columns */}
          <div className="md:col-span-6 grid grid-cols-1 sm:grid-cols-3 gap-8 text-white/90">
            {/* there2b */}
            <div>
              <h3 className="font-extrabold text-xl mb-3">
                {t('footer.there2b_header')}
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/listings?searchType=brands"
                    className="hover:underline"
                  >
                    {t('footer.brands')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/listings?searchType=events"
                    className="hover:underline"
                  >
                    {t('footer.events')}
                  </Link>
                </li>
                <li>
                  <Link to="/purpose" className="hover:underline">
                    {t('footer.purpose')}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h3 className="font-extrabold text-xl mb-3">
                {t('footer.legal_header')}
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/terms-conditions" className="hover:underline">
                    {t('footer.terms')}
                  </Link>
                </li>
                <li>
                  <Link to="/cookie-policy" className="hover:underline">
                    {t('footer.cookies')}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h3 className="font-extrabold text-xl mb-3">
                {t('footer.support_header')}
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/contact-us" className="hover:underline">
                    {t('footer.contact_us')}
                  </Link>
                </li>
                <li>
                  <Link to="/payments" className="hover:underline">
                    {t('footer.payments')}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left text-sm text-white/80">
          <p>© {new Date().getFullYear()} there2b. {t('footer.rights')}</p>
          <div className="flex items-center">
            <img
              src={process.env.PUBLIC_URL + '/easypay_variants.png'}
              alt="Payment Methods"
              className="h-8 w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
